import * as React from 'react';
import { Configure } from 'react-instantsearch-core';
import { connectStateResults } from 'react-instantsearch-dom';
import { InfinitePagination as InfinitePagination$1 } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import '../Algolia/components/FacetsMobile/FacetsMobile.js';
import 'use-onclickoutside';
import '../types.js';
import '../Algolia/components/CurrentRefinements/CurrentRefinements.js';
import '../Algolia/components/FacetInputList/ConnectedFacetInputList.js';
import '../Algolia/components/FacetInputPriceRange/ConnectedFacetInputPriceRange.js';
import '../Algolia/components/VirtualFacets/VirtualFacets.js';
import '../Algolia/components/SortBy/SortBy.js';
import '../Algolia/AlgoliaSearch.js';
import { useAlgoliaConfig } from '../Algolia/AlgoliaConfig.js';
import '@swc/helpers';
import 'algoliasearch/lite';
import 'lodash/merge';
import '@grandvisionhq/utils';
import '../Algolia/utils/query-string.js';
import '../Algolia/AlgoliaAnalytics.js';
import '../CrossSellProducts/utils/create-algolia-filters.js';
import { useInfinitePageLength } from './use-infinite-page-length.js';

const ConnectedInfinitePagination = ({ searchResults , searchState , searching , labelKey ,  })=>{
    var ref;
    const { getLabel  } = useIntl();
    const { pageSize =24  } = useAlgoliaConfig();
    const [length, setLength] = useInfinitePageLength(searchState, pageSize);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Configure, {
        offset: 0,
        length: length
    }), /*#__PURE__*/ React.createElement(InfinitePagination$1, {
        onClick: setLength,
        buttonLabel: getLabel('search.loadMore'),
        labelKey: `${labelKey ? labelKey : 'search.pagingStatus'}`,
        loaded: length,
        isLoading: searching,
        total: searchResults.nbHits,
        pageNr: (ref = searchState.configure) === null || ref === void 0 ? void 0 : ref.page
    }));
};
var InfinitePagination = connectStateResults(ConnectedInfinitePagination);

export { ConnectedInfinitePagination, InfinitePagination as default };
//# sourceMappingURL=InfinitePagination.js.map
